import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import BlogListingPage from "../pages/blog-listing/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/itaobuyspreadsheet-guide",
    element: <BlogPage />,
  },
  {
    path: "/blog",
    element: <BlogListingPage />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;